import { Role } from '@ps20/bff-models';
import { IAppState } from '../localStore';

const VERTRIEBSTELEFONIE_ROLES: ReadonlySet<Role> = new Set([
  Role.VTTEL,
  Role.VTGEV,
  Role.VTKVM,
  Role.VTKUS,
]);

const MAKLERBETREUER_MAKLER_UVM_ROLES: ReadonlySet<Role> = new Set([
  Role.MAKLERBETREUER,
  Role.MAKLER,
  Role.UVM,
]);

export const isVertreter = (state: IAppState): boolean => state.role === Role.VERTRETER;

export const isMaklerbetreuerOrNVOrLKBOrVTTEL = ({ role }: IAppState): boolean =>
   [Role.MAKLERBETREUER,
   Role.NEBENBERUFSVERTRETER,
   Role.OLB,
   Role.GENO,
   Role.AGENTURANGESTELLTER,
   Role.LEITENDER_KUNDENBETREUER,
   Role.VTTEL,
   Role.VTGEV,
   Role.MAKLER,
   Role.UVM,
   Role.VTKUS,
   Role.VTKVM,
   Role.UWPSHRK,
   Role.UNDERWRITER_UNFALL].includes(role);

export const isMaklerbetreuerOrMaklerOrUvm = ({ role }: IAppState): boolean =>
  MAKLERBETREUER_MAKLER_UVM_ROLES.has(role);

export const isVertriebstelefonie = ({ role }: IAppState): boolean =>
  VERTRIEBSTELEFONIE_ROLES.has(role);
